import CategoryTagItem from "./CategoryTagitem";
import { Colors, FlexBox, useBreakpoint } from "@brg/ui";
import styled from "styled-components";
import { FC, useCallback, useEffect, useRef, useState } from "react";
import { Tag } from "@brg/api";
import { CreateLinkTo } from "../../constants/linkTo";
import { useHistory } from "react-router-dom";
import { TagItemWrapper } from "./styles.mobile";
import { TAG_ADMIN_OPERATION } from "_deziiign/main/pages/MainTagAdminPage/MainTagAdminPage";
import { CategoryWrapper } from "./styles";
import {LayoutConst} from "../../../core";

// const THRESHOLD_X = 550;
// const MAX_THRESHOLD_UP = 300;
// const MAX_THRESHOLD_DOWN = 50;

const CategoryListWrapper = styled(FlexBox)<{ customHeight?: number, fullWidth?: boolean }>`
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  width: ${({ fullWidth }) => fullWidth ? '100%' : '368px'};
  height: ${p => 'calc(100vh - '+(p?.customHeight || 380)+'px)'};
  padding-bottom: 100px;
  min-width: ${({ fullWidth }) => fullWidth ? 'auto' : '368px'};
  padding-right: 16px;
  

  &::-webkit-scrollbar {
    height: 1px;
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
  }

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    width: ${({ fullWidth }) => fullWidth ? '100%' : '200px'};
    min-width: ${({ fullWidth }) => fullWidth ? 'auto' : '200px'};
    height: ${p => p?.customHeight ? 'calc(100vh - '+(p?.customHeight || 100)+'px)' : '100%'};
    padding-right: 0px;

    &::-webkit-scrollbar {
      height: 0px;
      width: 0px;
    }
  }
  
  ${TagItemWrapper} {
    padding-left: 16px;
    margin-left: 0;
    &:hover { 
      background-color: ${({ theme }) => theme.tags.selectedCategory};
    }
    &:after {
      width: 100%;
      left: 0;
    }
  }
`

interface CategoryListProps {
  tags: Tag[];
  onHover: (tagId: number) => void;
  onRemove: (tagId: string, type: string) => void;
  currentCategory: string | null;
  customHeight?: number;
  isClickable?: boolean;
  isRemoveble?: boolean;
  fullWidth?: boolean;
  setHideMore?: any;
}

const CategoryList:FC<CategoryListProps> = ({
  tags,
  onHover,
  onRemove,
  currentCategory,
  customHeight,
  isClickable,
  isRemoveble,
  fullWidth,
  setHideMore
}) => {
  const history = useHistory();
  const listRef = useRef<any>(null);
  const clientCoorX = useRef(0);
  const clientCoorY = useRef(0);
  const [disableHover, setDisableHover] = useState(false);
  const is992 = useBreakpoint(LayoutConst.screen.m);

  let timeout = 0;

  const onFetchData = (categoryId: any) => onHover(categoryId)

  const onMouseMove = useCallback((ev: any) => {
    const { clientX, clientY } = ev;
    const dataId = ev.target?.['dataset']?.['id'];
    let blockRequest = false;

    if (!dataId || is992) return;

    if (clientX > clientCoorX.current && clientY < clientCoorY.current) {
      clientCoorY.current = clientY;
      clientCoorX.current = clientX;
      setDisableHover(true)
      blockRequest = true
    } else if (clientX > clientCoorX.current && clientY > clientCoorY.current) {
      clientCoorY.current = clientY;
      clientCoorX.current = clientX;
      setDisableHover(true)
      blockRequest = true
    }

    clientCoorY.current = clientY;
    clientCoorX.current = clientX;

    if(!blockRequest) {
      setDisableHover(false)
      if (currentCategory !== dataId) {
        onFetchData(dataId);
      }
    }
  } , [clientCoorX, clientCoorY, currentCategory])

  useEffect(() => {
    listRef?.current?.addEventListener('mousemove', onMouseMove)

    return () => {
      listRef?.current?.removeEventListener('mousemove', onMouseMove)
    }
  } , [currentCategory, timeout])

  const isDisabled = useCallback(
    (tagId: string) => !!disableHover && tagId !== currentCategory
  , [disableHover, currentCategory])

  const isSelected = useCallback(
    (tagId: string) => tagId === currentCategory , [currentCategory])


  return (
    <CategoryListWrapper ref={listRef} customHeight={customHeight} fullWidth={fullWidth}>
      
      {
        tags.map((tag) => {
          if (isRemoveble && !!onRemove) {
            return (
              <CategoryWrapper justify="space-between">
                <CategoryTagItem
                  key={tag.tagId}
                  tag={tag}
                  isHoverMode
                  disableHover={isDisabled(tag?.tagId)}
                  selected={isSelected(tag.tagId)}
                  onSelect={() => {
                    setHideMore(false)
                    if (is992) {
                      onFetchData(tag?.tagId);
                      return
                    }

                    if (tag.tagId !== 'all' && isClickable) {
                      history.push(CreateLinkTo.tag(tag.tagId));
                    }
                  }}
                />
                <div onClick={() => onRemove(tag?.tagId, TAG_ADMIN_OPERATION.remove)}>
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.42676 2.46289C8.59833 2.46289 7.92676 3.13446 7.92676 3.96289V4.46289H4.42676C3.59833 4.46289 2.92676 5.13446 2.92676 5.96289V6.96289C2.92676 7.79132 3.59833 8.46289 4.42676 8.46289H4.92676V20.9629C4.92676 21.7913 5.59833 22.4629 6.42676 22.4629H17.4268C18.2552 22.4629 18.9268 21.7913 18.9268 20.9629V8.46289H19.4268C20.2552 8.46289 20.9268 7.79132 20.9268 6.96289V5.96289C20.9268 5.13446 20.2552 4.46289 19.4268 4.46289H15.9268V3.96289C15.9268 3.13446 15.2552 2.46289 14.4268 2.46289H9.42676ZM14.9268 4.46289V3.96289C14.9268 3.68675 14.7029 3.46289 14.4268 3.46289H9.42676C9.15062 3.46289 8.92676 3.68675 8.92676 3.96289V4.46289H14.9268ZM7.92676 5.46289H4.42676C4.15062 5.46289 3.92676 5.68675 3.92676 5.96289V6.96289C3.92676 7.23903 4.15062 7.46289 4.42676 7.46289H4.92676H5.42676H18.4268H18.9268H19.4268C19.7029 7.46289 19.9268 7.23903 19.9268 6.96289V5.96289C19.9268 5.68675 19.7029 5.46289 19.4268 5.46289H15.9268H15.4268H8.42676H7.92676ZM5.92676 8.46289H17.9268V20.9629C17.9268 21.239 17.7029 21.4629 17.4268 21.4629H6.42676C6.15062 21.4629 5.92676 21.239 5.92676 20.9629V8.46289Z" fill="#909090"/>
                  </svg>
                </div>
              </CategoryWrapper>
            )
          }
          return (
            <CategoryTagItem
              key={tag.tagId}
              tag={tag}
              isHoverMode
              disableHover={isDisabled(tag?.tagId)}
              selected={isSelected(tag.tagId)}
              onSelect={() => {
                setHideMore(false)
                if (is992) {
                  onFetchData(tag?.tagId);
                  return
                }

                if (tag.tagId !== 'all' && isClickable) {
                  history.push(CreateLinkTo.tag(tag.tagId));
                }
              }}
            />
          )
        })
      }
    </CategoryListWrapper>
  )
}

export default CategoryList;import CategoryTagItem from "./CategoryTagitem";
import { Colors, FlexBox, useBreakpoint } from "@brg/ui";
import styled from "styled-components";
import { FC, useCallback, useEffect, useRef, useState } from "react";
import { Tag } from "@brg/api";
import { CreateLinkTo } from "../../constants/linkTo";
import { useHistory } from "react-router-dom";
import { TagItemWrapper } from "./styles.mobile";
import { TAG_ADMIN_OPERATION } from "_deziiign/main/pages/MainTagAdminPage/MainTagAdminPage";
import { CategoryWrapper } from "./styles";
import {LayoutConst} from "../../../core";

// const THRESHOLD_X = 550;
// const MAX_THRESHOLD_UP = 300;
// const MAX_THRESHOLD_DOWN = 50;

const CategoryListWrapper = styled(FlexBox)<{ customHeight?: number, fullWidth?: boolean }>`
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  width: ${({ fullWidth }) => fullWidth ? '100%' : '368px'};
  height: ${p => 'calc(100vh - '+(p?.customHeight || 380)+'px)'};
  padding-bottom: 100px;
  min-width: ${({ fullWidth }) => fullWidth ? 'auto' : '368px'};
  padding-right: 16px;
  

  &::-webkit-scrollbar {
    height: 1px;
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
  }

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    width: ${({ fullWidth }) => fullWidth ? '100%' : '200px'};
    min-width: ${({ fullWidth }) => fullWidth ? 'auto' : '200px'};
    height: ${p => p?.customHeight ? 'calc(100vh - '+(p?.customHeight || 100)+'px)' : '100%'};
    padding-right: 0px;

    &::-webkit-scrollbar {
      height: 0px;
      width: 0px;
    }
  }
  
  ${TagItemWrapper} {
    padding-left: 16px;
    margin-left: 0;
    &:hover { 
      background-color: ${({ theme }) => theme.tags.selectedCategory};
    }
    &:after {
      width: 100%;
      left: 0;
    }
  }
`

interface CategoryListProps {
  tags: Tag[];
  onHover: (tagId: number) => void;
  onRemove: (tagId: string, type: string) => void;
  currentCategory: string | null;
  customHeight?: number;
  isClickable?: boolean;
  isRemoveble?: boolean;
  fullWidth?: boolean;
  setHideMore?: any;
}

const CategoryList:FC<CategoryListProps> = ({
  tags,
  onHover,
  onRemove,
  currentCategory,
  customHeight,
  isClickable,
  isRemoveble,
  fullWidth,
  setHideMore
}) => {
  const history = useHistory();
  const listRef = useRef<any>(null);
  const clientCoorX = useRef(0);
  const clientCoorY = useRef(0);
  const [disableHover, setDisableHover] = useState(false);
  const is992 = useBreakpoint(LayoutConst.screen.m);

  let timeout = 0;

  const onFetchData = (categoryId: any) => onHover(categoryId)

  const onMouseMove = useCallback((ev: any) => {
    const { clientX, clientY } = ev;
    const dataId = ev.target?.['dataset']?.['id'];
    let blockRequest = false;

    if (!dataId || is992) return;

    if (clientX > clientCoorX.current && clientY < clientCoorY.current) {
      clientCoorY.current = clientY;
      clientCoorX.current = clientX;
      setDisableHover(true)
      blockRequest = true
    } else if (clientX > clientCoorX.current && clientY > clientCoorY.current) {
      clientCoorY.current = clientY;
      clientCoorX.current = clientX;
      setDisableHover(true)
      blockRequest = true
    }

    clientCoorY.current = clientY;
    clientCoorX.current = clientX;

    if(!blockRequest) {
      setDisableHover(false)
      if (currentCategory !== dataId) {
        onFetchData(dataId);
      }
    }
  } , [clientCoorX, clientCoorY, currentCategory])

  useEffect(() => {
    listRef?.current?.addEventListener('mousemove', onMouseMove)

    return () => {
      listRef?.current?.removeEventListener('mousemove', onMouseMove)
    }
  } , [currentCategory, timeout])

  const isDisabled = useCallback(
    (tagId: string) => !!disableHover && tagId !== currentCategory
  , [disableHover, currentCategory])

  const isSelected = useCallback(
    (tagId: string) => tagId === currentCategory , [currentCategory])


  return (
    <CategoryListWrapper ref={listRef} customHeight={customHeight} fullWidth={fullWidth}>
      
      {
        tags.map((tag) => {
          if (isRemoveble && !!onRemove) {
            return (
              <CategoryWrapper justify="space-between">
                <CategoryTagItem
                  key={tag.tagId}
                  tag={tag}
                  isHoverMode
                  disableHover={isDisabled(tag?.tagId)}
                  selected={isSelected(tag.tagId)}
                  onSelect={() => {
                    setHideMore(false)
                    if (is992) {
                      onFetchData(tag?.tagId);
                      return
                    }

                    if (tag.tagId !== 'all' && isClickable) {
                      history.push(CreateLinkTo.tag(tag.tagId));
                    }
                  }}
                />
                <div onClick={() => onRemove(tag?.tagId, TAG_ADMIN_OPERATION.remove)}>
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.42676 2.46289C8.59833 2.46289 7.92676 3.13446 7.92676 3.96289V4.46289H4.42676C3.59833 4.46289 2.92676 5.13446 2.92676 5.96289V6.96289C2.92676 7.79132 3.59833 8.46289 4.42676 8.46289H4.92676V20.9629C4.92676 21.7913 5.59833 22.4629 6.42676 22.4629H17.4268C18.2552 22.4629 18.9268 21.7913 18.9268 20.9629V8.46289H19.4268C20.2552 8.46289 20.9268 7.79132 20.9268 6.96289V5.96289C20.9268 5.13446 20.2552 4.46289 19.4268 4.46289H15.9268V3.96289C15.9268 3.13446 15.2552 2.46289 14.4268 2.46289H9.42676ZM14.9268 4.46289V3.96289C14.9268 3.68675 14.7029 3.46289 14.4268 3.46289H9.42676C9.15062 3.46289 8.92676 3.68675 8.92676 3.96289V4.46289H14.9268ZM7.92676 5.46289H4.42676C4.15062 5.46289 3.92676 5.68675 3.92676 5.96289V6.96289C3.92676 7.23903 4.15062 7.46289 4.42676 7.46289H4.92676H5.42676H18.4268H18.9268H19.4268C19.7029 7.46289 19.9268 7.23903 19.9268 6.96289V5.96289C19.9268 5.68675 19.7029 5.46289 19.4268 5.46289H15.9268H15.4268H8.42676H7.92676ZM5.92676 8.46289H17.9268V20.9629C17.9268 21.239 17.7029 21.4629 17.4268 21.4629H6.42676C6.15062 21.4629 5.92676 21.239 5.92676 20.9629V8.46289Z" fill="#909090"/>
                  </svg>
                </div>
              </CategoryWrapper>
            )
          }
          return (
            <CategoryTagItem
              key={tag.tagId}
              tag={tag}
              isHoverMode
              disableHover={isDisabled(tag?.tagId)}
              selected={isSelected(tag.tagId)}
              onSelect={() => {
                setHideMore(false)
                if (is992) {
                  onFetchData(tag?.tagId);
                  return
                }

                if (tag.tagId !== 'all' && isClickable) {
                  history.push(CreateLinkTo.tag(tag.tagId));
                }
              }}
            />
          )
        })
      }
    </CategoryListWrapper>
  )
}

export default CategoryList;